/* eslint-disable react-hooks/exhaustive-deps */
import toast from "react-hot-toast";
import * as React from "react";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";
import ClearIcon from "@mui/icons-material/Clear";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import {
  AppBar,
  Button,
  Toolbar,
  Typography,
  IconButton,
  Grow,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbar } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import API from "../../Api/api";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});

const columns = [
  {
    field: "code",
    headerName: "Code",
    minWidth: 250,
  },
  {
    field: "certificate_number",
    headerName: "Certificate Number",
    minWidth: 170,
    align: "left",
  },
  {
    field: "institution",
    headerName: "Institution",
    minWidth: 170,
    align: "left",
  },
  {
    field: "investment_type",
    headerName: "Investment Type",
    minWidth: 170,
    align: "left",
  },
  {
    field: "regulator",
    headerName: "Regulator",
    minWidth: 170,
    align: "left",
  },
  {
    field: "rate",
    headerName: "Rate",
    minWidth: 170,
    align: "left",
  },
  {
    field: "purchase_date",
    headerName: "Purchase Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "maturity_date",
    headerName: "Maturity Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "tenure",
    headerName: "Tenure",
    minWidth: 170,
    align: "left",
  },
  {
    field: "cost",
    headerName: "Cost",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "impairment",
    headerName: "Impairment",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },

  {
    field: "fair_value",
    headerName: "Fair Value",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "total_interest",
    headerName: "Total Interest",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "daily_interest",
    headerName: "Interest Charged",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },

  {
    field: "status",
    headerName: "Status",
    minWidth: 170,
    align: "left",
  },
];

export default function UndefinedInvestmentReport() {
  const [view, setView] = React.useState("");
  const [filterData, setFilterData] = React.useState({
    regulator: "",
    investment_type: "",
    interest_charged_start: "",
    interest_charged_end: "",
    purchased_start: "",
    purchased_end: "",
    maturity_start: "",
    maturity_end: "",
  });
  const totalCost = [];
  const totalinterest_charged = [];
  const accumInterest = [];
  const fairValue = [];

  function createData(
    id,
    code,
    certificate_number,
    institution,
    investment_type,
    regulator,
    rate,
    purchase_date,
    maturity_date,
    tenure,
    cost,
    impairment,
    total_interest,
    daily_interest,
    rate_type,
  ) {
    //  we are check whether an asset is exhausted or not

    let status = moment(maturity_date) > moment() ? "Active" : "Matured";
    // ----------------------------------------------------------------
    const date2 = moment();
    const date1 = moment(purchase_date);
    let days_earned = date2.diff(date1, "days") + 1;
    let interest_charged = days_earned * daily_interest;
    let days_unearned = tenure - days_earned;
    let cumulative_interest = days_earned * daily_interest;
    let interest_unearned = days_unearned * daily_interest;
    let fair_value =
      rate_type === "interest rate"
        ? cost + cumulative_interest - impairment
        : cost - impairment;
    // ! WE DON'T CHARGE DEPN ON LAND

    // ! Revalued Started here -----------------------//!

    //! ------------Revalued ended here-------------------------///!

    // !------------start------------------------------------
    // checking if the asset has been exhausted;
    // if (cost - cumulative_interest < 1) {
    //   interest_unearned = 0;
    // }
    if (status === "Matured") {
      days_earned = moment(maturity_date).diff(purchase_date, "days");
      days_unearned = 0;

      cumulative_interest = days_earned * daily_interest;
      interest_unearned = days_unearned * daily_interest;
      interest_charged = 0;
      fair_value =
        rate_type === "interest rate"
          ? cost + cumulative_interest - impairment
          : cost - impairment;
    }
    // !------------- Exhausted Checking End---------------------------

    // ! things to do when the interest_charged start date and end date are all selected--------------//Start

    if (filterData.interest_charged_start && filterData.interest_charged_end) {
      if (
        filterData.interest_charged_start &&
        filterData.interest_charged_end &&
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) < moment(filterData.interest_charged_start) &&
        status === "Matured"
      ) {
        cumulative_interest = cost;
        interest_unearned = 0;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }

      if (moment(filterData.interest_charged_end) < moment(purchase_date)) {
        cost = 0;
        fair_value = 0;
        interest_unearned = 0;
        cumulative_interest = 0;
        days_earned = 0;
        days_unearned = 0;
        interest_charged = 0;

        status = "investment was not available then";
      }

      // check if the interest_charged end date is within the exhausted date //! Start------------

      if (
        moment(purchase_date) <= moment(filterData.interest_charged_start) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      // ----------!End!----------------//!

      // we will check if the purchase date is less than the start date and the exhaustion date  is greater than the start date and also the exhaustion date is less than the end date//! start

      if (
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        const diff = moment(maturity_date).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );
        //! this is where I did the negative changes
        days_earned = cummDateDiff;
        days_unearned = tenure - cummDateDiff;
        interest_unearned = (tenure - cummDateDiff) * daily_interest;
        cumulative_interest = cummDateDiff * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = diff * daily_interest;
        // ! the change was done here
        // ! I am looking for a scenario where the purchase date is less than the start and the maturity is less than the end
      }

      // ----------------------//!End---------------------
      if (moment(maturity_date) < moment(filterData.interest_charged_start)) {
        interest_unearned = 0;
        cumulative_interest = days_earned * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }
      // if (
      //   moment(purchase_date) < moment(filterData.interest_charged_start) &&
      //   moment(maturity_date) <= moment(filterData.interest_charged_end)
      // ) {
      //   days_earned = tenure;
      // }
      // we will check if the purchase date is greater than the start date and the exhaustion date is greater than the end date//!start
      if (
        moment(purchase_date) > moment(filterData.interest_charged_start) &&
        moment(purchase_date) <= moment(filterData.interest_charged_end) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
        // ! another change too was done here, equal sign was added to the second check
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      if (
        moment(purchase_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        //  we will check if the purchase date is greater than the start date and the exhaustion date is less than the end date;
        // if both the purchase and the exhaustion date are in btn the start and end date;
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff;
        days_unearned = 0;
        interest_unearned = 0;
        cumulative_interest = tenure * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        const diff = moment(maturity_date).diff(moment(purchase_date), "days");
        interest_charged = diff * daily_interest;
      }
    }
    // -----------------------End of instance-------------------//!End
    // ! we will be catching all disposed assets instances here

    //  we will check if the disposal happened before the start date

    // we will check if the disposal date is greater than the start date and is less than or equal to the end date;

    // ! Depn start and depn end.-----------------------// End

    totalCost.push(cost);
    totalinterest_charged.push(interest_charged);
    accumInterest.push(cumulative_interest);
    fairValue.push(fair_value);
    return {
      id,
      code,
      certificate_number,
      institution,
      investment_type,
      regulator,
      rate,
      purchase_date,
      maturity_date,
      tenure,
      days_earned,
      days_unearned,
      cost,
      cumulative_interest,
      interest_unearned,
      impairment,
      fair_value,
      total_interest,
      interest_charged,
      daily_interest,
      status,
      rate_type,
    };
  }

  const regulators = useSelector((state) => state.regulators);
  const investmentTypes = useSelector((state) => state.investmentTypes);

  const approvedUndefinedInvestments = useSelector(
    (state) => state.approvedUndefinedInvestments,
  );

  const [data, setData] = React.useState(approvedUndefinedInvestments);

  const rows = data.map((data) =>
    createData(
      data._id,
      data.code,
      data.certificate_number,
      data.institution,
      data.investment_type,
      data.regulator,
      data.rate,
      moment(data.purchase_date).format("YYYY-MM-DD"),
      moment(data.maturity_date).format("YYYY-MM-DD"),
      data.tenure,
      data.cost,
      data.impaired_amount,
      data.total_interest,
      data.period_interest || 0,
      data.rate_type,
      data.matured_investment || "false",
    ),
  );
  const [allInvestments, setAllInvestments] = React.useState(
    approvedUndefinedInvestments,
  ); // Separate the original data array
  React.useEffect(() => {
    if (view === "all investments") {
      setData(allInvestments);
    } else if (view === "active investments") {
      const activeInvestments = allInvestments.filter(
        (investment) => moment(investment.maturity_date) > moment(),
      );
      setData(activeInvestments);
    } else if (view === "exhausted investments") {
      const exhaustedInvestments = allInvestments.filter(
        (investment) => moment(investment.maturity_date) < moment(),
      );
      setData(exhaustedInvestments);
    }
  }, [view, allInvestments]);

  React.useEffect(() => {
    const activeInvestments = data.filter(
      (data) => moment(data.maturity_date) > moment(),
    );
    setData(activeInvestments);
  }, []);
  const regulator = filterData.regulator
    ? `&regulator=${filterData.regulator}`
    : "";
  const investment_type = filterData.investment_type
    ? `&investment_type=${filterData.investment_type}`
    : "";
  const purchase_date_start = filterData.purchased_start
    ? `&purchase_date[gte]=${filterData.purchased_start}`
    : "";
  const interest_start = filterData.interest_charged_start
    ? `&date[gte]=${filterData.interest_charged_start}`
    : "";
  const interest_end = filterData.interest_charged_end
    ? `&date[lte]=${filterData.interest_charged_end}`
    : "";
  const purchase_date_end = filterData.purchased_end
    ? `&purchase_date[lte]=${filterData.purchased_end}`
    : "";
  const expiration_start = filterData.maturity_start
    ? `&maturity_date[gte]=${filterData.maturity_start}`
    : "";
  const expiration_end = filterData.maturity_end
    ? `&maturity_date[lte]=${filterData.maturity_end}`
    : "";

  const query = `/api/v1/investment?approved=true&rate_type[eq]=undefined rate${regulator}${investment_type}${purchase_date_end}${purchase_date_start}${expiration_start}${expiration_end}${interest_end}`;
  const fetchInvestment = async () => {
    if (
      !regulator &&
      !investment_type &&
      !purchase_date_end &&
      !purchase_date_start &&
      !expiration_end &&
      !interest_end &&
      !interest_start &&
      !expiration_start
    ) {
      toast.error("Choose at least one filter before generating a report");
      return;
    }

    let res;
    const fetchingId = toast.loading("Fetching data...");
    try {
      res = await API.get(query);
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
      return;
    } finally {
      toast.remove(fetchingId);
    }
    if (Array.isArray(res.data) && res.data.length > 0) {
      const investmentsArrayWithHighestDate = res.data.reduce(
        (results, item) => {
          const {
            code,
            _id,
            date,
            total_interest,
            purchase_date,
            period_interest,
            certificate_number,
            charges,
            cost,
            daily_interest,
            impaired,
            impaired_amount,
            institution,
            investment_type,
            maturity_date,
            rate,
            rate_type,
            regulator,
            tenure,
            year_days,
            uploaded_by,
            matured_investment,
          } = item;
          if (!results[code] || moment(date) > moment(results[code].date)) {
            results[code] = {
              code,
              _id,
              date,
              total_interest,
              purchase_date,
              period_interest,
              certificate_number,
              charges,
              cost,
              daily_interest,
              impaired,
              impaired_amount,
              institution,
              investment_type,
              maturity_date,
              rate,
              rate_type,
              regulator,
              tenure,
              year_days,
              uploaded_by,
              matured_investment,
            };
          }
          return results;
        },
        {},
      );
      const datesArray = Object.values(investmentsArrayWithHighestDate);
      setData(datesArray);
      setAllInvestments(datesArray);
    } else {
      setData([]);
      toast.error("No investments match these filters");
    }
  };

  const totalInvestmentCost = totalCost.reduce((acc, val) => acc + val, 0);
  const totalInvestmentInterestCharged = rows.reduce(
    (acc, val) => acc + val.daily_interest,
    0,
  );

  const totalInvestmentFairValue = fairValue.reduce((acc, val) => acc + val, 0);
  function clearFilter() {
    setData(approvedUndefinedInvestments);
    setAllInvestments(approvedUndefinedInvestments);
    setFilterData({
      regulator: "",
      investment_type: "",
      interest_charged_start: "",
      interest_charged_end: "",
      purchased_start: "",
      purchased_end: "",
      maturity_start: "",
      maturity_end: "",
    });
  }
  const [filteredRows] = React.useState(approvedUndefinedInvestments);

  const handleFilterModelChange = (newModel) => {
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "contains"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().includes(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "equals"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter(
        (data) =>
          data[fields]?.toString().toLowerCase() === value?.toLowerCase(),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "startsWith"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().startsWith(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "endsWith"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().endsWith(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isEmpty"
    ) {
      const fields = newModel?.items[0]?.field;
      const filterData = filteredRows.filter(
        (data) => data[fields] === null || "" || undefined,
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isNotEmpty"
    ) {
      const fields = newModel?.items[0]?.field;
      const filterData = filteredRows.filter(
        (data) => data[fields] != null || "" || undefined,
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isAnyOf"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        value?.includes(data[fields]),
      );
      setData(filterData);
    }
  };
  const dataArr = [];

  const handleOnCellClick = (data) => {
    const rowId = data?.row.id;

    if (data?.formattedValue === "no" && !dataArr.includes(rowId)) {
      dataArr.push(rowId);
    } else if (data?.formattedValue === "yes" && dataArr.includes(rowId)) {
      const index = dataArr.indexOf(rowId);
      dataArr.splice(index, 1);
    }
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        style={{ backgroundColor: "#CBD0D8", color: "#000" }}
      >
        <GridToolbar style={{ color: "#000" }} />
        {dataArr.length > 0 && (
          <Grow in={dataArr.length > 0} timeout={1000}>
            <div>
              <Tooltip title="remove selected">
                <IconButton onClick={removeSelected}>
                  <ClearIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Keep Selected only">
                <IconButton onClick={keepSelected}>
                  <DoneAllIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Grow>
        )}
      </GridToolbarContainer>
    );
  }
  function keepSelected() {
    const filter = data.filter((data) => dataArr.includes(data._id));
    setData(filter);
  }
  function removeSelected() {
    const filter = data.filter((data) => !dataArr.includes(data._id));
    setData(filter);
  }
  return (
    <div>
      <Paper
        elevation={10}
        style={{ backgroundColor: "#f8f8f8", border: "1px solid #3D4F58" }}
      >
        <div
          elevation={16}
          style={{
            fontSize: "14px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "row",
            // alignItems: "center",
            justifyContent: "space-between",
            height: "95px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", rowGap: 9 }}>
            <FormControl size="small" sx={{ m: 1, width: 140 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Regulator
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterData.regulator}
                onChange={(e) =>
                  setFilterData({ ...filterData, regulator: e.target.value })
                }
                label="Category"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {regulators.map((reg) => (
                  <MenuItem key={reg._id} value={reg.regulator}>
                    {reg.regulator}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ m: 1, width: 140 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Investment type
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterData.investment_type}
                onChange={(e) =>
                  setFilterData({
                    ...filterData,
                    investment_type: e.target.value,
                  })
                }
                label="Category"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {investmentTypes.map((invest) => (
                  <MenuItem key={invest._id} value={invest.investment_type}>
                    {invest.investment_type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                color: "#333D51",
              }}
              htmlFor="start-date"
            >
              Interest charged start
            </label>
            <input
              value={filterData.interest_charged_start}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  interest_charged_start: e.target.value,
                })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",

                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="start-date"
              type="date"
              size={"large"}
              name="start-date"
            />

            <label
              style={{ fontWeight: "bold", fontSize: "14px", color: "#333D51" }}
              htmlFor="end-date"
            >
              Interest charged end
            </label>
            <input
              value={filterData.interest_charged_end}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  interest_charged_end: e.target.value,
                })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="end-date"
              type="date"
              size="small"
              name="end-date"
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "bold", fontSize: "14px", color: "#333D51" }}
              htmlFor="acq-start-date"
            >
              Purchased start
            </label>
            <input
              value={filterData.purchased_start}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  purchased_start: e.target.value,
                })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="acq-start-date"
              type="date"
              size="small"
            />
            <label
              style={{ fontWeight: "bold", fontSize: "14px", color: "#333D51" }}
              htmlFor="acq-start-date"
            >
              Purchased end
            </label>
            <input
              value={filterData.purchased_end}
              onChange={(e) =>
                setFilterData({ ...filterData, purchased_end: e.target.value })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "bold", fontSize: "14px", color: "#333D51" }}
              htmlFor="acq-start-date"
            >
              Maturity start
            </label>
            <input
              value={filterData.maturity_start}
              onChange={(e) =>
                setFilterData({ ...filterData, maturity_start: e.target.value })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
            <label
              style={{ fontWeight: "bold", fontSize: "14px", color: "#333D51" }}
              htmlFor="acq-start-date"
            >
              Maturity end
            </label>
            <input
              value={filterData.maturity_end}
              onChange={(e) =>
                setFilterData({ ...filterData, maturity_end: e.target.value })
              }
              style={{
                // alignItems: "center",
                alignText: "center",
                width: "200px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                padding: "2px",
                borderRadius: "5px",
                // backgroundColor: "#cccc",
                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={fetchInvestment}
            size="small"
            variant="contained"
            style={{
              backgroundColor: "#333D51",
              margin: "5px",
              height: "35px",
            }}
          >
            Generate Report
          </Button>

          <FormControl size="small" sx={{ m: 1, width: 140 }}>
            <InputLabel id="demo-simple-select-standard-label">View</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              value={view}
              onChange={(e) => setView(e.target.value)}
              id="demo-simple-select-standard"
              label="Category"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="active investments">Active Investments</MenuItem>
              <MenuItem value="exhausted investments">
                Exhausted Investments
              </MenuItem>
              <MenuItem value="all investments">All Investments</MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={clearFilter}
            size="small"
            variant="contained"
            style={{
              backgroundColor: "#f47373",
              height: "35px",
              marginRight: "5px",
            }}
          >
            Clear Filter
          </Button>
        </div>
      </Paper>

      <Paper sx={{ width: "100%", height: "60vh", paddingBottom: "50px" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          {...rows}
          slots={{ toolbar: CustomToolbar }}
          checkboxSelection
          onCellClick={handleOnCellClick}
          onFilterModelChange={handleFilterModelChange}
        />
        <AppBar
          position="fixed"
          style={{ backgroundColor: "#CBD0D8", color: "#000000" }}
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <Typography style={{}}>
              Total Cost: {currencyFormatter.format(totalInvestmentCost)}
            </Typography>

            <Typography style={{}}>
              Interest charged:{" "}
              {currencyFormatter.format(totalInvestmentInterestCharged)}
            </Typography>
            <Typography style={{}}>
              Fair Value: {currencyFormatter.format(totalInvestmentFairValue)}
            </Typography>
          </Toolbar>
        </AppBar>
      </Paper>
    </div>
  );
}
